module.exports = __webpack_public_path__ + "img/trust-wallet.c2f9e10c.png";